import React, { useEffect, useState } from "react";
import { apiClient } from "@/lib/apiClient";
import { Input } from "@/components/ui/input";

// Iter313: Zweck / Notiz / «privat bezahlt» direkt beim Upload (Posteingang)
export function InboxUploadOptions({ companyId, value, onChange }) {
  const [purposes, setPurposes] = useState([]);
  const [employees, setEmployees] = useState([]);

  useEffect(() => {
    if (!companyId) return;
    apiClient.get(`/companies/${companyId}/booking-rules/purposes`).then((r) => setPurposes(r.data || [])).catch(() => {});
    apiClient.get(`/companies/${companyId}/employees`).then((r) => setEmployees((r.data || []).filter((e) => !e.archived_at))).catch(() => {});
  }, [companyId]);

  const set = (k, v) => onChange({ ...value, [k]: v });
  const sel = purposes.find((p) => p.key === value.purpose);

  return (
    <div className="mb-3 grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-2 items-start" data-testid="inbox-upload-options" onClick={(e) => e.stopPropagation()}>
      <div>
        <select
          className="border border-slate-200 rounded-md px-2 py-1.5 text-sm w-full bg-white"
          value={value.purpose}
          onChange={(e) => set("purpose", e.target.value)}
          data-testid="inbox-upload-purpose-select"
        >
          <option value="">Wofür ist der Beleg? (optional)</option>
          {purposes.map((p) => (
            <option key={p.key} value={p.key}>{p.label}{p.account ? ` → ${p.account}` : ""}</option>
          ))}
        </select>
        {sel?.asset_account && (
          <p className="text-[11px] text-slate-500 mt-1">ab CHF 1'000 automatisch als Anlage ({sel.asset_account})</p>
        )}
      </div>
      <Input
        value={value.note}
        onChange={(e) => set("note", e.target.value)}
        placeholder="Notiz, z.B. «Team-Lunch Juli» oder «Schreibtisch Büro»"
        data-testid="inbox-upload-note-input"
      />
      <div className="flex flex-col gap-1">
        <label className="flex items-center gap-2 text-xs text-slate-700 whitespace-nowrap cursor-pointer" data-testid="inbox-upload-paid-by-employee-label">
          <input type="checkbox" checked={value.paid_by_employee} onChange={(e) => set("paid_by_employee", e.target.checked)} data-testid="inbox-upload-paid-by-employee-checkbox" />
          Mitarbeiter hat privat bezahlt (Spesen)
        </label>
        {value.paid_by_employee && (
          <select
            className="border border-slate-200 rounded-md px-2 py-1 text-xs bg-white"
            value={value.employee_id}
            onChange={(e) => set("employee_id", e.target.value)}
            data-testid="inbox-upload-employee-select"
          >
            <option value="">Mitarbeiter wählen …</option>
            {employees.map((e) => (
              <option key={e._id} value={e._id}>{e.first_name} {e.last_name}</option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
}

const CONF = {
  high: { label: "sicher", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  medium: { label: "KI – bitte prüfen", cls: "bg-amber-100 text-amber-900 border-amber-200" },
  low: { label: "unsicher", cls: "bg-rose-100 text-rose-800 border-rose-200" },
};

export function AccountConfidenceBadge({ extracted, itemId }) {
  const c = CONF[extracted?.account_confidence];
  if (!c) return null;
  return (
    <span className={`rounded-full border px-1.5 py-0.5 text-[9px] font-semibold ${c.cls}`} title={extracted.account_reason || ""} data-testid={`inbox-account-confidence-${itemId}`}>
      {c.label}
    </span>
  );
}
